export const TYPE_DISCUSSION = 'type_discussion';
export const TYPE_COMPLETED = 'type_completed';

export const DISCUSSION_ITEM_CHARACTER_LIMIT = 255;
